import styled from 'styled-components';

export default styled.div`
  position: relative;
  overflow: hidden;
  transition: 0.3s ease;
  top: -12px;
`;
